import React, { useState, useEffect } from 'react';
import NotificationDropdown from './NotificationDropdown';
import MessagesDropdown from './MessagesDropdown';
import ProfileDropdown from './ProfileDropdown';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <style jsx>{`
        .header-modern {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(10px);
          -webkit-backdrop-filter: blur(10px);
          border-bottom: 1px solid rgba(0, 0, 0, 0.1);
          box-shadow: 0 2px 20px rgba(0, 0, 0, 0.1);
          transition: all 0.3s ease;
        }
        
        .header-scrolled {
          background: rgba(255, 255, 255, 0.98);
          box-shadow: 0 4px 30px rgba(0, 0, 0, 0.15);
        }
        
        .logo {
          text-decoration: none !important;
          transition: transform 0.2s ease;
        }
        
        .logo:hover {
          transform: translateY(-1px);
        }
        
        .logo img {
          width: 40px;
          height: 40px;
          border-radius: 8px;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          padding: 8px;
          box-shadow: 0 4px 15px rgba(102, 126, 234, 0.3);
          transition: all 0.3s ease;
        }
        
        .logo:hover img {
          box-shadow: 0 6px 25px rgba(102, 126, 234, 0.4);
          transform: scale(1.05);
        }
        
        .logo span {
          font-weight: 700;
          font-size: 1.5rem;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          background-clip: text;
          margin-left: 12px;
          letter-spacing: -0.5px;
        }
        
        .header-nav ul {
          list-style: none;
          margin: 0;
          padding: 0;
        }
        
        .header-nav ul li {
          position: relative;
        }
        
        /* Market Information Display - Fixed height and borders */
        .market-info {
          background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
          border-radius: 8px;
          padding: 6px 16px;
          margin-right: 1rem;
          border: 1px solid #e0e0e0;
          box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.05);
          height: 40px;
          display: flex;
          align-items: center;
          max-width: fit-content;
        }
        
        .market-item {
          margin: 0 12px;
          text-align: center;
          white-space: nowrap;
        }
        
        .market-label {
          font-size: 9px;
          font-weight: 600;
          color: #6c757d;
          margin-bottom: 1px;
          text-transform: uppercase;
          letter-spacing: 0.3px;
          line-height: 1;
        }
        
        .market-value {
          font-size: 12px;
          font-weight: 700;
          color: #2c3e50;
          line-height: 1;
        }
        
        .market-positive {
          color: #28a745;
        }
        
        .market-negative {
          color: #dc3545;
        }
        
        .market-trend {
          font-size: 8px;
          margin-left: 3px;
        }
        
        /* Enhanced dropdown styling - Fixed overlapping */
        .nav-item {
          position: relative;
          margin: 0 8px;
        }
        
        .nav-item .btn {
          background: none;
          border: none;
          padding: 12px;
          border-radius: 50%;
          transition: all 0.2s ease;
          position: relative;
          width: 44px;
          height: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
        }
        
        .nav-item .btn:hover {
          background: rgba(102, 126, 234, 0.1);
          transform: translateY(-1px);
        }
        
        .nav-item .btn:focus {
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.2);
        }
        
        .nav-item .btn i {
          font-size: 18px;
          color: #6c757d;
        }
        
        /* Notification badges - Fixed positioning */
        .notification-badge {
          position: absolute;
          top: 8px;
          right: 8px;
          background: linear-gradient(135deg, #ff6b6b, #ee5a52);
          color: white;
          border-radius: 50%;
          width: 16px;
          height: 16px;
          font-size: 9px;
          font-weight: bold;
          display: flex;
          align-items: center;
          justify-content: center;
          border: 2px solid white;
          z-index: 10;
          animation: pulse 2s infinite;
        }
        
        .message-badge {
          background: linear-gradient(135deg, #51cf66, #40c057);
        }
        
        @keyframes pulse {
          0% { transform: scale(1); }
          50% { transform: scale(1.1); }
          100% { transform: scale(1); }
        }
        
        /* Mobile responsiveness */
        @media (max-width: 768px) {
          .market-info {
            display: none;
          }
          
          .logo span {
            font-size: 1.2rem;
          }
        }
        
        @media (max-width: 576px) {
          .logo span.d-none.d-lg-block {
            display: block !important;
            font-size: 1rem;
          }
          
          .market-info {
            display: none;
          }
        }
        
        /* Professional user avatar */
        .user-avatar {
          width: 35px;
          height: 35px;
          border-radius: 50%;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: bold;
          font-size: 14px;
          margin-left: 10px;
          border: 2px solid white;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        }
        
        /* Smooth transitions for all interactive elements */
        * {
          transition: all 0.2s ease;
        }
        
        /* Professional color scheme */
        .header-modern {
          --primary-color: #667eea;
          --secondary-color: #764ba2;
          --accent-color: #f8f9fa;
          --text-dark: #2c3e50;
          --text-light: #6c757d;
        }
      `}</style>

      <header
        id="header"
        className={`header fixed-top d-flex align-items-center header-modern ${isScrolled ? 'header-scrolled' : ''}`}
      >
        <div className="container-fluid">
          <div className="row align-items-center">
            <div className="col-auto">
              <div className="d-flex align-items-center justify-content-between">
                <a href="/" className="logo d-flex align-items-center">
                  <img src="/assets/img/logo.png" alt="TraDaApP Logo" />
                  <span className="d-none d-lg-block">TraDaApP</span>
                </a>
              </div>
            </div>

            {/* Market Information Display */}
            <div className="col d-none d-md-block">
              <div className="market-info d-flex justify-content-center">
                <div className="market-item">
                  <div className="market-label">NIFTY 50</div>
                  <div className="market-value market-positive">
                    19,674.25
                    <span className="market-trend">▲ +0.85%</span>
                  </div>
                </div>
                <div className="market-item">
                  <div className="market-label">SENSEX</div>
                  <div className="market-value market-positive">
                    66,230.15
                    <span className="market-trend">▲ +1.12%</span>
                  </div>
                </div>
                <div className="market-item">
                  <div className="market-label">GOLD</div>
                  <div className="market-value market-negative">
                    ₹62,850
                    <span className="market-trend">▼ -0.45%</span>
                  </div>
                </div>
                <div className="market-item">
                  <div className="market-label">USD/INR</div>
                  <div className="market-value market-positive">
                    83.25
                    <span className="market-trend">▲ +0.12%</span>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-auto">
              <nav className="header-nav">
                <ul className="d-flex align-items-center">
                  {/* Watchlist Dropdown - You can replace NotificationDropdown with this */}


                  <li className="nav-item">
                    <NotificationDropdown />

                  </li>

                  <li className="nav-item">
                    <MessagesDropdown />
                    <span className="notification-badge message-badge">7</span>
                  </li>

                  <li className="nav-item">
                    <ProfileDropdown />

                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </header>
    </>
  );
};

export default Header;